import WarehouseIcon from "@redotech/redo-icons/warehouse.svg";
import { RedoOutboundLabelsRpcClient } from "@redotech/redo-merchant-fulfillment-rpc/client";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

interface FulfillmentServiceOption {
  _id: string;
  name: string;
}

const entry = fgFilterEntries.assignedFulfillmentService;

export const AssignedFulfillmentServiceFilter = (
  rpcClient: RedoOutboundLabelsRpcClient,
): ArrayStringTableFilter<FulfillmentServiceOption | string> => ({
  type: entry.type,
  itemLabel: "fulfillment service",
  operators: entry.operators,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: WarehouseIcon,
  valueFetcher: async (_filters, signal) => {
    const { fulfillmentServices } =
      await rpcClient.getFulfillmentServicesThatFulfillForTeam({}, { signal });
    return fulfillmentServices;
  },
  itemGenerator: (item) => ({
    id: typeof item === "string" ? item : item._id,
    value: item,
    type: "text",
    text: typeof item === "string" ? item : item.name,
  }),
  stringify: (item) => (typeof item === "string" ? item : item._id),
  display: (item) => (typeof item === "string" ? item : item.name),
  displayName: entry.displayName,
});
